var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.909668,11C33.4313354,8.1668701,30.9672241,6,28,6s-5.4313354,2.1668701-5.909668,5H2v2h20.090332 C22.5686646,15.8331299,25.0327759,18,28,18s5.4313354-2.1668701,5.909668-5H46v-2H33.909668z M28,16c-2.2060547,0-4-1.7939453-4-4 s1.7939453-4,4-4s4,1.7939453,4,4S30.2060547,16,28,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,30c-2.9672241,0-5.4313354,2.1668701-5.909668,5H2v2h28.090332C30.5686646,39.8331299,33.0327759,42,36,42 s5.4313354-2.1668701,5.909668-5H46v-2h-4.090332C41.4313354,32.1668701,38.9672241,30,36,30z M36,40c-2.2060547,0-4-1.7939453-4-4 s1.7939453-4,4-4s4,1.7939453,4,4S38.2060547,40,36,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-2.9672241,0-5.4313354,2.1668701-5.909668,5H2v2h4.090332C6.5686646,27.8331299,9.0327759,30,12,30 s5.4313354-2.1668701,5.909668-5H46v-2H17.909668C17.4313354,20.1668701,14.9672241,18,12,18z M12,28c-2.2060547,0-4-1.7939453-4-4 s1.7939453-4,4-4s4,1.7939453,4,4S14.2060547,28,12,28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMedium);
export default __webpack_public_path__ + "static/media/filter--medium.24ffdd59876f7062902712bc6358361f.svg";
export { ForwardRef as ReactComponent };